// extracted by mini-css-extract-plugin
module.exports = {"slotButton":"TimeSlotsMobile_slotButton__5l_Ld","arrowIcon":"TimeSlotsMobile_arrowIcon__FKxm8"};